module.exports = __webpack_public_path__ + "static/img/title-dz.44a033aa.png";